module.exports = __webpack_public_path__ + "static/media/download.247004b2.png";